const requestsSaver: Record<string, Promise<Record<string, Record<string, string | undefined>>>> = {};
import axios from 'axios';
import { computed, ref } from 'vue';

const allowedLanguages = ['en', 'si', 'de', 'it', 'se', 'ru'];
const defaultLanguage = 'si';
const translations = ref<Record<string, Record<string, string | undefined>>>({});
const _language = ref<string>(defaultLanguage);

function fetchTranslations(language: string) {
  if (!requestsSaver[language]) {
    requestsSaver[language] = axios
      .get(`/api/translations/${language}`)
      .then((response) => response.data)
      .catch((error) => {
        console.error('Error fetching translations', error);
        return {};
      });
  }
  return requestsSaver[language];
}

const __ = (key: string): string => {
  if (key === '') {
    return '';
  }
  if (!translations.value[language.value]) {
    return ''; //maybe return key here, for now hide it
  }

  const translation = translations.value[language.value][key];
  if (!translation) {
    console.error('Translation not found:', key);
    return ''; //maybe return key here, for now hide it
  }
  return translation;
};

const language = computed({
  get: () => {
    return _language.value;
  },
  set: (value: string) => {
    if (value && !allowedLanguages.includes(value)) {
      throw new Error('Invalid language');
    }
    fetchTranslations(value).then((t) => {
      _language.value = value;
      translations.value = t;
    });
  },
});

function setLanguage(lang: string) {
  language.value = lang;
}
function getLanguage() {
  return language.value || defaultLanguage;
}

export default __;
export { setLanguage, getLanguage, allowedLanguages, defaultLanguage, language };
